import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import {
    LoanOptionApiEndpoints,
    LoanOptionFormDetail,
    LoanOptionResponse,
    LoanOptionState,
    UpdateLoanOptionFormDetailResponse,
} from './loanOptionTypes';

import { initialStateLoanOption as initialState } from './loanOptionDefaultValue';
import { ApiStatus } from '../../types';
const loanOptionSlice = createSlice({
    name: 'loanOption',
    initialState,
    reducers: {
        updateLoanOptionsEndpoints: (state, action: PayloadAction<LoanOptionApiEndpoints>) => {
            state.apiEndpoints = action.payload;
        },   
        submitLoanOption: (state) => state,

        getLoanOptions(state) {
            state.getLoanOptionApiStatus = ApiStatus.Pending;
        },
        getLoanOptionsFulfilled(state, action: PayloadAction<LoanOptionResponse>) {
            state.getLoanOptionApiStatus = ApiStatus.Fulfilled;

            const { content, loanOptionData } = action.payload;

            state.content = content;
            state.loanOptionData = loanOptionData;
            state.loanOptionFormDetail = loanOptionData.loanOptionFormDetail;
        },
        getLoanOptionsRejected(state) {
            state.getLoanOptionApiStatus = ApiStatus.Rejected;
        },
        updateLoanOptionFormDetailClient(state, action: PayloadAction<LoanOptionFormDetail>) {
            state.loanOptionFormDetail = action.payload;
        },
        updateLoanOptionFormDetailServer: (state, action: PayloadAction<LoanOptionFormDetail>) => state,
        updateLoanOptionFormDetailPending(state) {
            state.updateLoanOptionFormDetailApiStatus = ApiStatus.Pending;
        },
        updateLoanOptionFormDetailFulfilled(state, action: PayloadAction<UpdateLoanOptionFormDetailResponse>) {
           
            state.loanOptionFormDetail = {
                ...state.loanOptionFormDetail,
                ...action.payload,               
            };
            
            state.updateLoanOptionFormDetailApiStatus = ApiStatus.Fulfilled;
        },
        updateLoanOptionFormDetailRejected(state) {
            state.updateLoanOptionFormDetailApiStatus = ApiStatus.Rejected;
        },
        resetLoanOptionFormDetailStatus(state) {
            state.getLoanOptionApiStatus = ApiStatus.Idle;
            state.updateLoanOptionFormDetailApiStatus = ApiStatus.Idle;
        },
        applyNowClick: (state, action: PayloadAction<number>) => state,

    },
});

export const {
    updateLoanOptionsEndpoints,
    submitLoanOption,
    getLoanOptions,
    getLoanOptionsFulfilled,
    getLoanOptionsRejected,
    updateLoanOptionFormDetailClient,
    updateLoanOptionFormDetailServer,
    updateLoanOptionFormDetailPending,
    updateLoanOptionFormDetailFulfilled,
    updateLoanOptionFormDetailRejected,
    resetLoanOptionFormDetailStatus,
    applyNowClick,
} = loanOptionSlice.actions;

export const loanOptionReducer: Reducer<LoanOptionState, AnyAction> = loanOptionSlice.reducer;
